<script setup lang="ts">
import { RouterView } from 'vue-router'
import PublicNav from '@/components/public/PublicNav.vue'
import PublicFooter from '@/components/public/PublicFooter.vue'
</script>

<template>
  <div class="flex min-h-screen flex-col bg-white">
    <PublicNav />
    <main class="flex-1">
      <RouterView />
    </main>
    <PublicFooter />
  </div>
</template>
